// extracted by mini-css-extract-plugin
module.exports = {"caret-wrapper":"i_Gz","expanded":"i_G0","caret":"i_G1"};